import React from 'react';

import { Grid, Stack, Typography } from '@mui/material';
import { maskCurrencyFormat } from 'util/masks';

interface Props {
  planPrice: number;
  discountValue: string;
  finalValue: string;
}

export const TutorPlanOrderResumeSubtotal: React.FC<Props> = ({
  planPrice,
  discountValue,
  finalValue,
}) => {
  return (
    <Grid item xs={12} md={3} spacing={2} mt={0.5}>
      <Stack spacing={1} direction="column">
        <Stack direction="row" justifyContent="space-between" spacing={2}>
          <Typography color="#4B4B4B" fontSize={14} fontWeight={700}>
            Subtotal
          </Typography>

          <Typography color="#4B4B4B" fontSize={14} fontWeight={400}>
            {maskCurrencyFormat(planPrice)}
          </Typography>
        </Stack>

        {discountValue ? (
          <>
            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Typography color="#4B4B4B" fontSize={14} fontWeight={700}>
                Desconto
              </Typography>

              <Typography color="#2E7D32" fontSize={14} fontWeight={400}>
                -{discountValue}
              </Typography>
            </Stack>

            <Stack direction="row" justifyContent="space-between" spacing={2}>
              <Typography color="#4B4B4B" fontSize={14} fontWeight={700}>
                Valor com desconto
              </Typography>

              <Typography color="#000000" fontSize={14} fontWeight={400}>
                {finalValue}
              </Typography>
            </Stack>
          </>
        ) : null}
      </Stack>
    </Grid>
  );
};
